const configBoardFilter = {
    notice: {
        getFunc: 'getNotice',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            wr_type: 'post',
        },
        pageRow: 10,
        deleteFunc: 'deleteNotice',
        deleteApiParamSet: {
            wr_type: 'post',
        },
        deleteKeyName: 'wr_id',
        deleteSuccessType: 500,
        deleteFailTypes: {
            '-1': '삭제에 실패하였습니다. 잠시 후 다시 시도해주세요.',
            '-2': '권한이 없습니다.',
            '-7': '잘못된 값입니다.',
        },
    },
    noticeCreate: {
        getFunc: 'getNotice',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
            wr_type: 'post',
        },
        subFunc: 'createNotice',
        parsingData: {
            title : 'wr_subject',
            content : 'wr_content',
            country: 'c_idx',
        },
        createApiParamSet: {
            wr_type: 'post',
        },
        resultAlertTxt: '공지사항이 등록되었습니다.',
        directUrl: 'back',
        detailSuccessType: 1,
        writeSuccessType: 300,
    },
    noticeUpdate: {
        getFunc: 'getNotice',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
            wr_type: 'post',
        },
        subFunc: 'updateNotice',
        parsingData: {
            id: 'wr_id',
            title : 'wr_subject',
            content : 'wr_content',
            country: 'c_idx',
        },
        createApiParamSet: {
            wr_type: 'post',
        },
        resultAlertTxt: '공지사항이 수정되었습니다.',
        directUrl: 'back',
        detailSuccessType: 200,
        writeSuccessType: 400,
    },
    faq: {
        getFunc: 'getFaq',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            wr_type: 'post',
        },
        pageRow: 10,
        deleteFunc: 'deleteFaq',
        deleteApiParamSet: {
            wr_type: 'post',
        },
        deleteKeyName: 'wr_id',
        deleteSuccessType: 500,
        deleteFailTypes: {
            '-1': '삭제에 실패하였습니다. 잠시 후 다시 시도해주세요.',
            '-2': '권한이 없습니다.',
            '-7': '잘못된 값입니다.',
        },
    },
    faqCreate: {
        getFunc: 'getFaq',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
        },
        subFunc: 'createFaq',
        parsingData: {
            title : 'wr_subject',
            content : 'wr_content',
            country: 'c_idx',
        },
        createApiParamSet: {

        },
        resultAlertTxt: 'FAQ가 등록되었습니다.',
        directUrl: 'back',
        detailSuccessType: 1,
        writeSuccessType: 300,
    },
    faqUpdate: {
        getFunc: 'getFaq',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
        },
        subFunc: 'updateFaq',
        parsingData: {
            id: 'wr_id',
            title : 'wr_subject',
            content : 'wr_content',
            country: 'c_idx',
        },
        createApiParamSet: {
        },
        resultAlertTxt: 'FAQ가 수정되었습니다.',
        directUrl: 'back',
        detailSuccessType: 200,
        writeSuccessType: 400,
    },
    refund: {
        getFunc: 'getRefund',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            r_type: 'question',
            opa: 1,
            opw: 1,
        },
        pageRow: 10,
        deleteFunc: null,
        deleteApiParamSet: {},
        deleteKeyName: null,
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-1': '삭제에 실패하였습니다. 잠시 후 다시 시도해주세요.',
            '-2': '권한이 없습니다.',
            '-7': '잘못된 값입니다.',
        },
    },
    refundAnswer: {
        getCategoryFunc: null,
        getFunc: 'getRefund',
        createFunc: 'createRefundAnswer',
        updateFunc: 'updateRefundAnswer',
        detailApiParamSet: {
            ip: 0,
            r_type: 'question',
            opa: 1,
            opw: 1,
        },
        parsingData: {
            id : 'wr_parent',
            answerTitle : 'wr_subject',
            answerContent : 'wr_content',
            status: 'ri_status',
        },
        createApiParamSet: {
            r_type: 'answer'
        },
        answerKeyName: 'wr_id',
        detailSuccessType: 1,
    },
    qa: {
        getFunc: 'getQa',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            wr:1,
            cmt:1,
        },
        pageRow: 10,
        deleteFunc: null,
        deleteApiParamSet: {},
        deleteKeyName: null,
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-1': '삭제에 실패하였습니다. 잠시 후 다시 시도해주세요.',
            '-2': '권한이 없습니다.',
            '-7': '잘못된 값입니다.',
        },
    },
    qaAnswer: {
        getCategoryFunc: null,
        getFunc: 'getQa',
        createFunc: 'createQaAnswer',
        updateFunc: 'updateQaAnswer',
        detailApiParamSet: {
            ip: 0,
            cmt:1,
            cmtd:1,
            wr:1
        },
        parsingData: {
            id : 'wr_parent',
            answerTitle : 'wr_subject',
            answerContent : 'wr_content',
        },
        createApiParamSet: {
        },
        answerKeyName: 'wr_id',
        detailSuccessType: 200,
    },

    feedback: {
        getFunc: 'getFeedback',
        getCategoryFunc: null,
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            wr:1,
            cmt:1,
        },
        pageRow: 10,
        deleteFunc: null,
        deleteApiParamSet: {},
        deleteKeyName: null,
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-1': '삭제에 실패하였습니다. 잠시 후 다시 시도해주세요.',
            '-2': '권한이 없습니다.',
            '-7': '잘못된 값입니다.',
        },
    },
    feedbackAnswer: {
        getCategoryFunc: null,
        getFunc: 'getFeedback',
        createFunc: 'createFeedbackAnswer',
        updateFunc: 'updateFeedbackAnswer',
        detailApiParamSet: {
            ip: 0,
            cmt:1,
            cmtd:1,
            wr:1
        },
        parsingData: {
            id : 'wr_parent',
            answerTitle : 'wr_subject',
            answerContent : 'wr_content',
        },
        createApiParamSet: {
        },
        answerKeyName: 'wr_id',
        detailSuccessType: 200,
    },
    cafeNotice:{
        getFunc: 'getCafeNotice',
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
        },
        parsingData: {
        },
        pageRow: 10,
        isCafe : true,
        deleteFunc :'deleteCafeNotice',
        deleteApiParamsSet: {
            cafe: 'delete'
        },
        deleteSuccessType: 500,
        deleteFailTypes: {},
        deleteKeyName: 'wr_id',

    },
    cafeNoticeDetail : {
        getFunc: 'getCafeNotice',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
        },
        subFunc: null,
        parsingData: {},
        createApiParamSet: {},
        resultAlertTxt: '',
        directUrl: '',
        detailSuccessType: 200,
    },
    cafeConfigUpdate : {
        getFunc: 'getCafeConfig',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
        },
        subFunc: 'updateCafeConfig',
        parsingData: {
            content : 'cc_content',
        },
        createApiParamSet: {},
        resultAlertTxt: '카페 규정이 수정되었습니다.',
        directUrl: '',
        detailSuccessType: 1,
        isCafe : true
    },
    jstQna:{
        getFunc: 'getJstQna',
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            la: 1,
            cmt:1,
            wr:1,
        },
        pageRow: 10,
    },
    jstCreateQna: {
        getFunc: 'getJstQna',
        detailApiParamsSet: {
            ip: 0,
            la:1,
            cmt:1,
            cmtd:1,
            wr:1,
        },
        writeFunc: 'createJstQna',
        writeApiParamSet: {
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            wr_parent :'wr_parent'
        },
        directUrl: '',
        directType: 'back',
        keyName: '',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
    jstNotice:{
        getFunc: 'getNotice',
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            la: 1,
        },
        pageRow: 10,
        deleteFunc: 'deleteNotice',
        deleteApiParamsSet: {},
        deleteSuccessType: 500,
        deleteFailTypes: {},
        keyName: 'wr_id',
        deleteKeyName:"wr_id",
    },
    jstCreateNotice:{
        writeFunc: 'createNotice',
        writeApiParamSet: {
            language: 'create'
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            country: 'c_idx'
        },
        fileType: '',
        directUrl: '',
        directType: 'back',
        keyName: '',
        writeSuccessType: 300,
        writeFailTypes: {},
    },
    jstUpdateNotice:{
        writeFunc: 'updateNotice',
        getFunc:'getNotice',
        detailApiParamsSet: {
            ip: 0,
            la: 1,
        },
        writeApiParamSet: {
            language: 'update'
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            country: 'c_idx'
        },
        fileType: '',
        directUrl: '',
        directType: 'back',
        keyName: '',
        writeSuccessType: 400,
        writeFailTypes: {},
    },
    JstFaq:{
        getFunc: 'getJstFaq',
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            la: 1,
        },
        pageRow: 10,
        deleteFunc: 'deleteJstFaq',
        deleteApiParamsSet: {},
        deleteSuccessType: 500,
        deleteFailTypes: {},
        keyName: 'wr_id',
        deleteKeyName:"wr_id",
    },
    jstFaqCreate:{
        writeFunc: 'createJstFaq',
        writeApiParamSet: {
            language: 'create'
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            country: 'c_idx',
            bc_idx:'bc_idx',
        },
        fileType: '',
        directUrl: '',
        directType: 'back',
        keyName: '',
        writeSuccessType: 300,
        writeFailTypes: {},
    },
    jstFaqUpdate:{
        writeFunc: 'updateJstFaq',
        getFunc:'getJstFaq',
        detailApiParamsSet:{
            ip:0,
            la:1
        },
        writeApiParamSet: {
            language: 'update'
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
            country: 'c_idx',
            bc_idx:'bc_idx',
        },
        fileType: '',
        directUrl: '',
        directType: 'back',
        keyName: '',
        writeSuccessType: 400,
        writeFailTypes: {},
    },
    jstMail: {
        getFunc: 'getJstMail',
        paginationType: 'pagination',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            la: 1,
        },
        pageRow: 10,

        keyName: 'wr_id',
    },
    jstMailDetail: {
        getFunc: 'getJstMail',
        getCategoryFunc: null,
        detailApiParamSet: {
            ip: 0,
        },
        subFunc: null,
        parsingData: {},
        createApiParamSet: {},
        resultAlertTxt: '',
        directUrl: '',
        detailSuccessType: 1,
    },
    jstMailSend: {
        writeFunc: 'sendJstMail',
        writeApiParamSet: {
        },
        parsingData: {
            title: 'title',
            content: 'content',
            country: 'c_idx',
        },
        fileType: '',
        directUrl: '',
        directType: 'back',
        keyName: '',
        writeSuccessType: 1,
        writeFailTypes: {},
    },
}

export default {
    methods: {
        returnBoardFilterConfig(type) {
            return configBoardFilter[type];
        }
    },
    filterConfig: {
        su: {
            type: 'query',
            classname: 'searchInput',
        },
        co: {
            type: 'query',
            classname: 'searchInput',
        },
        ca: {
            type: 'query',
            classname: 'filterCategory',
        },
        cr: {
            type: 'between',
            classname: 'filterDate',
        },
        cid: {
            type: 'match',
            classname: 'filterCountry'
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        na: {
            type: 'query',
            classname: 'searchInput',
        },
        pa: {
            type: 'query',
            classname: 'searchInput',
        },
        oid: {
            type: 'query',
            classname: 'searchInput',
        },
        isa:{
            type:'match',
            classname:'searchOption'
        },
        ti: {
            type: 'query',
            classname: 'searchInput',
        },
    }
}
